import { useMemo } from 'react';
import { useGetPermission } from './business/useNewPermisson';
import { useOrgConfigStateValue } from './business/useOrgConfig';

export const useProductKnowledgePermission = () => {
  const {
    whiteListConfig: {
      KNOWLEDGE_SINGLE_ITEM,
      ENABLE_CHAT_HISTORY,
      ENABLE_SUPPLEMENT_KNOWLEDGE,
    } = {},
  } = useOrgConfigStateValue();
  const getPermission = useGetPermission();

  return useMemo(() => {
    return (
      (KNOWLEDGE_SINGLE_ITEM || ENABLE_CHAT_HISTORY || ENABLE_SUPPLEMENT_KNOWLEDGE) &&
      getPermission('商品知识')
    );
  }, [KNOWLEDGE_SINGLE_ITEM, ENABLE_CHAT_HISTORY, ENABLE_SUPPLEMENT_KNOWLEDGE, getPermission]);
};
